<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-card :header="cardTitle" v-if="sorteio" class="card-edicao">
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Titulo" class="mt-3">
            <b-form-input v-model="sorteio.titulo" />
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Descrição" class="mt-3">
            <b-form-input v-model="sorteio.descricao" />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Inicial" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="sorteio.datainicial"
              :language="ptBR"
              :format="customFormatter"
              disabled
            ></datepicker>
          </b-input-group>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-input-group prepend="Data Final" class="mt-3 date-input">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="sorteio.datafinal"
              :language="ptBR"
              :format="customFormatter"
              disabled
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="danger" class="mt-3 botao" @click="goBack()"
            >Cancelar</b-button
          >
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="success" class="mt-3 botao" @click="save()"
            >Salvar</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style>
.card-edicao > .card-body {
  padding-top: 0.25rem !important;
}
.date-input > .form-control > div > input {
  width: 100%;
  height: 100%;
  border: none;
  color: #5c6873;
}
.botao {
  width: 100% !important;
}
.input-group-text {
  width: 100px !important;
}
.form-control > input {
  width: calc(100% - 20px) !important;
  height: 100% !important;
  border: none !important;
  padding: 0 !important;
  color: #5c6873;
}
</style>


<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vuejs-timepicker";
import moment from "moment";

export default {
  name: "editar-sorteio",
  components: { Loading, Datepicker, moment, VueTimepicker },
  data: function () {
    return {
      isLoading: false,
      id: null,
      sorteio: null,
      cardTitle: "",
      ptBR: ptBR,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    buildParams(id, titulo, descricao, datainicial, datafinal) {
      return {
        id: id,
        titulo: titulo,
        descricao: descricao,
        datainicial: moment(datainicial).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        }),
        datafinal: moment(datafinal).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 0,
        }),
      };
    },

    async postSorteio() {
      const url = `${config.default.servidor}/gerencial/sorteio`;
      const data = this.buildParams(
        this.sorteio.id,
        this.sorteio.titulo,
        this.sorteio.descricao,
        this.sorteio.datainicial,
        this.sorteio.datafinal
      );

      try {
        const response = await axios({
          url,
          method: "post",
          data,
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          await this.$alert("Sorteio editado!", "Sucesso", "success");
          this.$router.go(-1);
        }
      } catch (error) {
        this.isLoading = false;
        console.log({ error });
        await this.$alert(
          "Falha ao editar o sorteio editado!",
          "Erro",
          "error"
        );
      }
    },

    async msgDate(msg) {
      this.isLoading = false;
      await this.$alert(msg, "Aviso", "warning");
    },

    async validateDates() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (moment(this.sorteio.datainicial).isAfter(this.sorteio.datafinal)) {
        return this.msgDate("Datas inválidas!");
      }

      if (moment(this.sorteio.datainicial).isAfter(tomorrow)) {
        return this.msgDate("Datas inválidas!");
      }

      if (moment(Date.now()).isAfter(this.sorteio.datafinal)) {
        return this.msgDate("Datas inválidas!");
      }

      this.sorteio.datainicial = moment(this.sorteio.datainicial).format();
      this.sorteio.datafinal = moment(this.sorteio.datafinal).format();
    },

    async save() {
      this.isLoading = true;
      await this.validateDates();
      await this.postSorteio();
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    async getDadosSorteio() {
      this.isLoading = true;
      const url = `${config.default.servidor}/gerencial/sorteio/dados/${this.id}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          this.sorteio = response.data.data;

          console.log({
            Titulo: this.sorteio.titulo,
            Descricao: this.sorteio.descricao,
          });
        }
      } catch (error) {
        this.isLoading = false;
        console.log({ error });
        await this.$alert(
          "Falha ao encontrar o sorteio indicado!",
          "Erro",
          "warning"
        );
        this.$router.go(-1);
      }
    },
  },
  async beforeMount() {
    this.isLoading = true;
    this.id = this.$route.params.id;
    this.cardTitle = `Sorteio`;
    if (this.id == null) {
      await this.$alert(
        "Não encontramos o sorteio indicado!",
        "Aviso",
        "warning"
      );
      this.$router.go(-1);
    } else {
      await this.getDadosSorteio();
    }
  },
};
</script>

